export const PDF_REQUEST_STATUS = [
    'Order Placed',
    'Generated',
    "Payment Pending",
    'Printed',
    'Mailed',
    'Completed'
];

export const availablePartners = ["CP-Letters", "CP-Postcards"];

export const availablePlans = ['Starter', 'Grow', 'Pro'];

export const FONT_BASE_URL = 'https://fonts-reachpersona.b-cdn.net/fonts';

export const REQUIRED_COLUMNS = [
    "ID",
    "envelope_name",
    "greeting_name",
    "ma-addr_line1",
    "ma-city",
    "ma-state",
    "ma-zip",
];
export const MAX_ROWS = 25000;
export const MAX_FILE_SIZE = 2 * 1024 * 1024;